import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';
import { AuthService } from '../core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class UnitConversionUtil {
  units = {
    // see https://de.wikipedia.org/wiki/L%C3%A4ngenma%C3%9F
    // in meters
    distance: {
      ft: 0.3048,
      in: 0.0254,
      km: 1000,
      m: 1,
      mi: 1609.344,
      nm: 1852,
      yd: 0.9144,
    },
    // see https://de.wikipedia.org/wiki/Geschwindigkeit#Einheiten
    // in m/s
    velocity: {
      'km/h': 0.2778,
      'm/s': 1,
      kn: 0.5144,
      mph: 0.4469,
    },
  };
  allowedTypes = Object.keys(this.units);

  milesCountryCodes = ['gb', 'us'];

  distanceDefault = 'km';
  shortDistanceDefault = 'm'; // TODO investigate a better way to do this
  velocityDefault = 'km/h';

  constructor(private auth: AuthService) {
    this.auth.user$.pipe(
      filter((profile) => profile !== null && profile.country !== undefined),
    ).subscribe((profile) => {
      const country = profile.country.toLowerCase();
      if (this.milesCountryCodes.includes(country)) {
        this.distanceDefault = 'mi';
        this.shortDistanceDefault = 'ft';
        this.velocityDefault = 'mph';
      }
    });
  }

  convertValue(value: number, type: string, unit: string, targetUnit: string = this[`${type}Default`]) {
    if (!this.allowedTypes.includes(type)) {
      throw new Error(`Unit type not allowed: ${type}`);
    }

    if (!this.units[type][unit] || !this.units[type][targetUnit]) {
      throw new Error(`Either value unit or target unit are not allowed for the type ${type}: ${unit}, ${targetUnit}`);
    }

    // convert to base unit and then to target unit
    return (value * this.units[type][unit]) / this.units[type][targetUnit];
  }
}
